import axios from "axios";
import React, { useEffect, useState } from "react";
import DescriptionIcon from "@mui/icons-material/Description";
import IconButton from "@mui/material/IconButton";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { MdDelete } from "react-icons/md";
import Swal from "sweetalert2";

const ItemsTable = ({ isPOData, setPOData, isViewMode, setErrors, errors }) => {
  const serverURL = process.env.REACT_APP_URL;
  const token = localStorage.getItem("token");
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [allProducts, setAllProducts] = useState([]);
  const [openDescription, setOpenDescription] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [index, setIndex] = useState(null);
  let productIndex = null;
  const openDescriptionModal = (product, index) => {
    setSelectedProduct(product);
    setOpenDescription(true);
    productIndex = index;
  };

  const handleAddItem = () => {
    setPOData((prev) => {
      const lastItem = prev.productItems?.[prev.productItems.length - 1];

      const nextId = lastItem ? lastItem.id + 1 : 1;

      return {
        ...prev,
        productItems: [
          ...(prev.productItems || []),
          {
            id: nextId,
            productName: "",
            hsnSac: null,
            quantity: "",
            rate: "",
            taxable: null,
            description: "",

            cgst: null,
            sgst: null,
            igst: null,
            cess: null,
            total: null,
            productId: "",
          },
        ],
      };
    });
  };
  const totalBeforeTax =
    isPOData?.productItems?.reduce(
      (sum, item) => sum + (item.taxable || 0),
      0,
    ) || 0;

  const totalCGSTAmount =
    isPOData?.productItems?.reduce(
      (sum, item) => sum + (item.cgstAmount || 0),
      0,
    ) || 0;

  const totalSGSTAmount =
    isPOData?.productItems?.reduce(
      (sum, item) => sum + (item.sgstAmount || 0),
      0,
    ) || 0;

  const totalIGSTAmount =
    isPOData?.productItems?.reduce(
      (sum, item) => sum + (item.igstAmount || 0),
      0,
    ) || 0;

  const totalCESSAmount =
    isPOData?.productItems?.reduce(
      (sum, item) => sum + (item.cessAmount || 0),
      0,
    ) || 0;

  let totalTax = isPOData?.isIGST
    ? totalIGSTAmount + totalCESSAmount
    : totalCGSTAmount + totalSGSTAmount + totalCESSAmount;

  const totalAfterTax = totalBeforeTax + totalTax;

  const grandTotal = totalAfterTax;

  const currentProduct = isPOData?.productItems?.find(
    (item) => item.id === selectedProduct?.id,
  );
  const handleDeleteItem = (id) => {
    setPOData((prev) => {
      if (prev.productItems.length === 1) {
        Swal.fire({
          icon: "warning",
          title: "Cannot Delete",
          text: "At least one product item is required in the Purchase Order.",
          confirmButtonText: "OK",
        });

        return prev;
      }

      const updatedItems = prev.productItems.filter((item) => item.id !== id);

      const poAmount = updatedItems.reduce(
        (sum, item) => sum + (item.taxable || 0),
        0,
      );

      const totalCGSTAmount = updatedItems.reduce(
        (sum, item) => sum + (item.cgstAmount || 0),
        0,
      );

      const totalSGSTAmount = updatedItems.reduce(
        (sum, item) => sum + (item.sgstAmount || 0),
        0,
      );

      const totalIGSTAmount = updatedItems.reduce(
        (sum, item) => sum + (item.igstAmount || 0),
        0,
      );

      const totalCESSAmount = updatedItems.reduce(
        (sum, item) => sum + (item.cessAmount || 0),
        0,
      );

      const totalTax =
        totalCGSTAmount + totalSGSTAmount + totalIGSTAmount + totalCESSAmount;

      const totalAfterTax = poAmount + totalTax;

      return {
        ...prev,
        productItems: updatedItems,
        poAmount,
        totalCGSTAmount,
        totalSGSTAmount,
        totalIGSTAmount,
        totalCESSAmount,
        totalTax,
        totalAfterTax,
        grandTotal: totalAfterTax,
      };
    });
  };
  const handleChange = (id, field, value, index) => {
    setIndex(index);
    setPOData((prev) => {
      const updatedItems = prev.productItems.map((item) => {
        if (item.id !== id) return item;

        const updatedItem = {
          ...item,
        };
        if (field === "productName") {
          const selectedProduct = allProducts.find(
            (prod) => prod.productType === value,
          );

          const gstRate = Number(selectedProduct?.gstTaxRate || 0);
          updatedItem.hsnSac = selectedProduct?.hsnNumber;

          if (isPOData?.isIGST) {
            updatedItem.cgst = 0;
            updatedItem.sgst = 0;
            updatedItem.igst = gstRate;
          } else {
            updatedItem.cgst = gstRate / 2;
            updatedItem.sgst = gstRate / 2;
            updatedItem.igst = 0;
          }
          updatedItem.description = selectedProduct?.description;
          updatedItem.rate = selectedProduct?.price;
          updatedItem.productId = selectedProduct?.itemId;
          updatedItem.quantity = 0;
        }
        updatedItem[field] = value;

        const quantity = Number(updatedItem.quantity) || 0;
        const rate = Number(updatedItem.rate) || 0;

        const taxable = quantity * rate;

        const cgstAmount = (taxable * (Number(updatedItem.cgst) || 0)) / 100;

        const sgstAmount = (taxable * (Number(updatedItem.sgst) || 0)) / 100;

        const igstAmount = (taxable * (Number(updatedItem.igst) || 0)) / 100;

        const cessAmount = (taxable * (Number(updatedItem.cess) || 0)) / 100;

        const total =
          taxable + cgstAmount + sgstAmount + igstAmount + cessAmount;

        return {
          ...updatedItem,
          taxable,
          cgstAmount,
          sgstAmount,
          igstAmount,
          cessAmount,
          total,
        };
      });

      // Summary Calculations
      const poAmount = updatedItems.reduce(
        (sum, item) => sum + (item.taxable || 0),
        0,
      );

      const totalCGSTAmount = updatedItems.reduce(
        (sum, item) => sum + (item.cgstAmount || 0),
        0,
      );

      const totalSGSTAmount = updatedItems.reduce(
        (sum, item) => sum + (item.sgstAmount || 0),
        0,
      );

      const totalIGSTAmount = updatedItems.reduce(
        (sum, item) => sum + (item.igstAmount || 0),
        0,
      );

      const totalCESSAmount = updatedItems.reduce(
        (sum, item) => sum + (item.cessAmount || 0),
        0,
      );

      const totalTax =
        totalCGSTAmount + totalSGSTAmount + totalIGSTAmount + totalCESSAmount;

      const totalAfterTax = poAmount + totalTax;

      const grandTotal = totalAfterTax;

      return {
        ...prev,
        productItems: updatedItems,
        poAmount,
        totalCGSTAmount,
        totalSGSTAmount,
        totalIGSTAmount,
        totalCESSAmount,
        totalTax,
        totalAfterTax,
        grandTotal,
      };
    });
    setErrors((prev) => {
      const copy = { ...prev };

      if (copy.productItems?.[index]?.[field]) {
        delete copy.productItems[index][field];
      }

      return copy;
    });
  };

  async function getAllProductsList() {
    try {
      const response = await axios.get(
        `${serverURL}/purchaseOrder/allProducts`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response?.data?.success) {
        setAllProducts(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching Installation Partners:", error);
    }
  }

  useEffect(() => {
    if (!isViewMode) {
      getAllProductsList();
    }
  }, []);
  console.log(isPOData?.gst_extra_charges);
  const taxHeaders = Object.entries(isPOData?.items?.[0]?.taxes_data || {})
    .filter(
      ([, value]) =>
        value &&
        typeof value === "object" &&
        value.tax_percentage !== undefined,
    )
    .map(([key]) => key.toUpperCase());

  console.log(taxHeaders);

  return (
    <div className="overflow-x-auto px-5 py-2  bg-white">
      <div className="border border-1 rounded-lg">
        <table className="max-w-full w-full  p-4">
          <thead className="bg-gray-100 p-10">
            <tr className="mb-5">
              <th
                style={{ fontSize: "14px", padding: "12px", fontWeight: "500" }}
              >
                #
              </th>

              <th
                style={{ fontSize: "14px", padding: "3px", fontWeight: "500" }}
              >
                Description
              </th>
              <th
                style={{ fontSize: "14px", padding: "3px", fontWeight: "500" }}
              >
                HSN/SAC Code
              </th>
              <th
                style={{ fontSize: "14px", padding: "3px", fontWeight: "500" }}
              >
                Quantity
              </th>
              <th
                style={{ fontSize: "14px", padding: "3px", fontWeight: "500" }}
              >
                Rate/sq ft
              </th>
              <th
                style={{ fontSize: "14px", padding: "3px", fontWeight: "500" }}
              >
                Taxable Amount
              </th>
              {taxHeaders.map((header) => (
                <th
                  style={{
                    fontSize: "14px",
                    padding: "3px",
                    fontWeight: "500",
                  }}
                  key={header}
                >
                  {header}
                  <div className="flex  w-[100px] justify-between mx-auto ">
                    <p> {`Rate  `}</p>
                    <p> {`    Amount`}</p>
                  </div>
                </th>
              ))}

              <th
                style={{ fontSize: "14px", padding: "3px", fontWeight: "500" }}
              >
                Total
              </th>
            </tr>
          </thead>

          <tbody>
            {isPOData?.items?.map((ele, index) => (
              <>
                <tr key={ele.id}>
                  <td className="border p-3">{index + 1}</td>

                  <td className="border p-3 w-[500px]">
                    {isViewMode ? (
                      <div className="space-y-1">
                        <p className=" text-base text-black">{ele.item_name}</p>
                        <div className="flex justify-start items-center gap-2">
                          <p className=" text-base text-[#171719] text-bold">
                            Item Id:
                          </p>
                          <p className=" text-base text-black text-bold">
                            {ele.itemid}
                          </p>
                        </div>
                        <p className=" text-base text-[#171719] text-bold">
                          Item Description:
                        </p>
                        <p className=" text-base text-[#747881]">
                          {ele?.custom_fields?.sjj1ifug?.value}
                        </p>

                        {ele?.description && (
                          <p className=" text-base text-[#747881]">
                            {ele.description}
                          </p>
                        )}
                      </div>
                    ) : (
                      <>
                        <div className="flex items-center gap-2">
                          <select
                            className="w-64 rounded-md border border-gray-300 p-2"
                            value={ele.productName}
                            onWheel={(e) => e.target.blur()}
                            onChange={(e) =>
                              handleChange(
                                ele.id,
                                "productName",
                                e.target.value,
                                index,
                              )
                            }
                          >
                            <option value="">Select Product</option>

                            {allProducts.map((product, index) => (
                              <option key={index} value={product.productType}>
                                {product.productType}
                              </option>
                            ))}
                          </select>

                          <IconButton
                            size="small"
                            onClick={() => openDescriptionModal(ele, index)}
                          >
                            <DescriptionIcon color="primary" />
                          </IconButton>
                        </div>
                        {errors?.productItems?.[index]?.productName && (
                          <p className="text-xs text-red-500">
                            {errors.productItems[index].productName}
                          </p>
                        )}
                      </>
                    )}
                  </td>

                  <td className="border p-3 text-center">
                    {isViewMode ? (
                      <p className=" text-[16px] text-[#747881]">
                        {ele.hsn_code || "-"}
                      </p>
                    ) : (
                      <>
                        <input
                          className="w-24 rounded border p-2"
                          placeholder="HSN/SAC"
                          maxLength={8}
                          onWheel={(e) => e.target.blur()}
                          value={
                            ele.hsnSac ||
                            allProducts.find(
                              (prod) =>
                                prod.productType ==
                                isPOData?.productItems[index]?.productName,
                            )?.hsnNumber
                          }
                          onChange={(e) => {
                            if (e.target.value.length <= 8) {
                              handleChange(
                                ele.id,
                                "hsnSac",
                                e.target.value,
                                index,
                              );
                            }
                          }}
                        />
                        {errors?.productItems?.[index]?.hsnSac && (
                          <p className="mt-1 text-xs text-red-500">
                            {errors.productItems[index].hsnSac}
                          </p>
                        )}
                      </>
                    )}
                  </td>

                  <td className="border p-3 text-center">
                    {isViewMode ? (
                      <p className=" text-[16px] text-[#747881]">
                        {" "}
                        {ele.quantity}
                      </p>
                    ) : (
                      <>
                        <input
                          type="number"
                          className="w-14 rounded border p-2"
                          value={ele.quantity}
                          min={0}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) =>
                            handleChange(
                              ele.id,
                              "quantity",
                              e.target.value,
                              index,
                            )
                          }
                        />
                        {errors?.productItems?.[index]?.quantity && (
                          <p className="mt-1 text-xs text-red-500">
                            {errors.productItems[index].quantity}
                          </p>
                        )}
                      </>
                    )}
                  </td>

                  <td className="border p-3 text-center">
                    {isViewMode && (
                      <p className=" text-[16px] text-[#747881]">
                        ₹ {Number(ele.price).toFixed(2)}
                      </p>
                    )}
                  </td>

                  <td className="border p-3 text-center">
                    {" "}
                    <p className=" text-[16px] text-[#747881]">
                      ₹ {ele.total_cost.toFixed(2)}
                    </p>
                  </td>

                  {Object.entries(ele?.taxes_data || {})
                    .filter(
                      ([key, value]) =>
                        value &&
                        typeof value === "object" &&
                        value.tax_percentage !== undefined,
                    )
                    .map(([key, value]) => (
                      <td key={key} className="border p-3 text-center">
                        <div className="flex gap-3 w-full justify-center items-center">
                          <p className="text-[16px] text-[#747881]">
                            {value.tax_percentage * 100}%
                          </p>
                          <p className="text-[16px] text-[#747881]">
                            ₹{value.tax_amount}
                          </p>
                        </div>
                      </td>
                    ))}

                  <td className="border p-3 text-center">
                    <p className=" text-[16px] text-[#747881]">
                      ₹ {Number(ele?.base_total_amount || 0).toFixed(2)}
                    </p>
                  </td>
                </tr>
                {isPOData?.gst_extra_charges?.map((charge, index) => (
                  <tr key={charge.uuid || index}>
                    <td>{}</td>

                    <td className="border p-3 text-center">
                      {" "}
                      <p className=" text-[16px] text-[#747881]">
                        {charge.name}
                      </p>
                    </td>
                    <td className="text-right"></td>
                    <td className="text-right"></td>
                    <td className="text-right"></td>

                    <td className="border p-3 text-center">
                      <p className=" text-[16px] text-[#747881]">
                        ₹{charge.base_total_amount?.toFixed(2)}
                      </p>
                    </td>

                    <td className="border p-3 text-center">
                      {charge.taxes?.map((tax, i) => (
                        <>
                          <div
                            key={tax.uuid || i}
                            className="flex justify-center items-center gap-3"
                          >
                            <p className=" text-[16px] text-[#747881]">
                              {(tax.tax_percentage * 100).toFixed(0)}%
                            </p>
                            <p className=" text-[16px] text-[#747881]">
                              {" "}
                              ₹{tax.tax_amount?.toFixed(2)}
                            </p>
                          </div>
                        </>
                      ))}
                    </td>

                    <td className="border p-3 text-center">
                      <p className=" text-[16px] text-[#747881]">
                        ₹{(charge.base_total_amount + charge.tax).toFixed(2)}
                      </p>
                    </td>
                  </tr>
                ))}
              </>
            ))}

            {
              <Dialog
                open={openDescription}
                onClose={() => setOpenDescription(false)}
                maxWidth="sm"
                fullWidth
              >
                <DialogTitle>Product Description</DialogTitle>

                <DialogContent>
                  <TextField
                    fullWidth
                    multiline
                    rows={4}
                    value={
                      currentProduct?.description ||
                      allProducts.find(
                        (prod) =>
                          prod.productType ==
                          isPOData?.productItems[index]?.productName,
                      )?.description
                    }
                    onChange={(e) => {
                      const value = e.target.value;

                      handleChange(selectedProduct.id, "description", value);

                      setSelectedProduct((prev) => ({
                        ...prev,
                        description: value,
                      }));
                    }}
                  />
                </DialogContent>

                <DialogActions>
                  <Button onClick={() => setOpenDescription(false)}>
                    Close
                  </Button>
                </DialogActions>
              </Dialog>
            }
          </tbody>
        </table>
        {!isViewMode && (
          <div className="bg-gray-100 p-3">
            <button
              onClick={handleAddItem}
              className="mt-4 text-blue-600 hover:underline"
            >
              + Add Item
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ItemsTable;
